import React, { useState } from 'react';
import { ExternalLink, RefreshCw, Loader2 } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

// Agent Seymour - embeds the self-hosted (rebranded Hermes) WebUI running on the
// Coastwise droplet behind HTTPS. The page is admin-only (gated by AdminPortal).
// To change the endpoint, update AGENT_URL.
const AGENT_URL = 'https://agent.coastwisetrade.com';

export default function AgentSeymour() {
  const [loading, setLoading] = useState(true);
  const [reloadKey, setReloadKey] = useState(0);

  const reload = () => {
    setLoading(true);
    setReloadKey((k) => k + 1);
  };

  return (
    <div className="flex flex-col h-[calc(100vh-5rem)]" data-testid="agent-seymour-page">
      {/* Embedded WebUI fills the space; controls float in the corner */}
      <div
        className="relative flex-1 bg-[var(--navy-900)] overflow-hidden"
        style={{ border: '1px solid var(--border)', borderRadius: 'var(--radius)' }}
      >
        {/* Floating icon controls */}
        <TooltipProvider delayDuration={150}>
          <div className="absolute top-2 right-2 z-20 flex items-center gap-1.5">
            <Tooltip>
              <TooltipTrigger asChild>
                <button
                  onClick={reload}
                  aria-label="Reload"
                  className="h-8 w-8 flex items-center justify-center rounded-md bg-[var(--cream)]/90 text-[var(--navy-800)] border border-[var(--border)] backdrop-blur transition-colors hover:bg-[var(--cream)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--navy-700)]"
                  data-testid="agent-reload"
                >
                  <RefreshCw className="h-4 w-4" />
                </button>
              </TooltipTrigger>
              <TooltipContent side="bottom">Reload</TooltipContent>
            </Tooltip>

            <Tooltip>
              <TooltipTrigger asChild>
                <a
                  href={AGENT_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Open in new tab"
                  className="h-8 w-8 flex items-center justify-center rounded-md bg-[var(--cream)]/90 text-[var(--navy-800)] border border-[var(--border)] backdrop-blur transition-colors hover:bg-[var(--cream)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--navy-700)]"
                  data-testid="agent-open-new-tab"
                >
                  <ExternalLink className="h-4 w-4" />
                </a>
              </TooltipTrigger>
              <TooltipContent side="bottom">Open in new tab</TooltipContent>
            </Tooltip>
          </div>
        </TooltipProvider>

        {loading && (
          <div
            className="absolute inset-0 flex flex-col items-center justify-center gap-3 z-10"
            style={{ background: 'var(--navy-900)' }}
            data-testid="agent-loading"
          >
            <Loader2 className="h-8 w-8 animate-spin text-[var(--cream)]" />
            <p className="text-[var(--cream)] text-sm">Connecting to Seymour...</p>
            <p className="text-[var(--cream)]/50 text-xs">{AGENT_URL}</p>
          </div>
        )}
        <iframe
          key={reloadKey}
          src={AGENT_URL}
          title="Agent Seymour"
          allow="microphone; clipboard-read; clipboard-write"
          onLoad={() => setLoading(false)}
          className="w-full h-full border-0 relative z-0"
          data-testid="agent-iframe"
        />
      </div>
    </div>
  );
}
